<!--
 * @Author: Nie Wie
 * @Date: 2020-02-21 14:15:02
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-06-02 15:50:59
 * @Description: 观测时报---覆盖率地图模式
 -->
<template>
  <div class="work-cover-map">
    <part-title title="全国开工强度"></part-title>
    <div class="work-cover-map__map" ref="hChart"></div>
    <!-- <div class="work-cover-map__timeline" ref="time-line"></div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Highcharts from 'highcharts/highmaps'
import PartTitle from '@/components/part-title'
import {
  guojieData,
  daoyuData,
  provinceData,
} from '@/assets/const-value/map-svg-path'

// import {
//   SPOT_LASTEST,
//   SPOT_STATISTICS,
// } from '@/assets/const-value/interface'

moment.locale('fr', {
  week: {
    dow: 1, // 星期一是一周的第一天
    doy: 4, // 判断一年中的第一周
  },
})
export default {
  components: {
    PartTitle,
  },
  data() {
    return {
      coverType: 'year', // 覆盖率类型： 年度覆盖率(year)、本周覆盖率(week)
      dataSource: null,
      coverageList: [],
    }
  },
  computed: {
    ...mapGetters({
      spotStaitstics: 'work/spotStaitstics',
    }),
  },
  watch: {
    spotStaitstics() {
      this.setOption()
    },
  },
  // created() {
  //   this.setOption()
  // },
  methods: {
    async setOption() {
      const seriesData = this.resolveData(this.spotStaitstics)
      const dataClass = this.getDataClasses(this.spotStaitstics)
      const series = [
        {
          type: 'map',
          name: 'province',
          color: '#cccccc',
          borderColor: '#dddddd',
          mapData: provinceData,
          data: seriesData,
          lineWidth: 2,
          joinBy: 'name',
          dataLabels: {
            enabled: true,
            color: '#222222',
            borderWidth: 0,
            style: {
              fontSize: 12,
              fontFamily: 'PingFangSC-Regular,PingFang SC',
              fontWeight: 400,
              textOutline: 'unset',
            },
            format: '{point.name}',
          },
          tooltip: {
            headerFormat: '',
            // eslint-disable-next-line object-shorthand
            pointFormatter: function () { // eslint-disable-line func-names
              return `${this.name}: ${this.value.toFixed(2)}`
            },
          },
        },
        {
          type: 'map',
          name: 'daoyu',
          color: '#737373',
          mapData: daoyuData,
          tooltip: {
            enabled: false,
          },
        },
        {
          type: 'mapline',
          name: 'guojie',
          color: '#737373',
          lineWidth: 2,
          data: guojieData,
          enableMouseTracking: false,
          tooltip: {
            enabled: false,
          },
        },
      ]
      const option = {
        chart: {
          ignoreHiddenSeries: false,
        },
        title: {
          text: null,
        },
        colorAxis: {
          dataClasses: dataClass,
          showFirstLabel: false,
          label: {
            align: 'center',
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          align: 'left',
          // backgroundColor: 'white',
          floating: true,
          layout: 'vertical',
          verticalAlign: 'bottom',
          labelFormatter: function () { // eslint-disable-line
            // 此方法不要使用箭头函数，函数中this指的是某一组数据，而不是Vue
            // 官方、论坛均没找到好的方式处理图例
            if (this.from === 'firstL') {
              this.legendItem.element.parentNode.style.display = 'none'
            }
            setTimeout(() => {
              if (this.from === 'firstL') {
                this.legendItem.element.innerHTML = '<tspan x="132" text-anchor="end">变化比例（%）</tspan>'
                this.legendItem.element.parentNode.lastElementChild.remove()
                this.legendItem.element.parentNode.style.display = ''
              } else if (this.from === 0.0001) {
                this.legendItem.element.innerHTML = `
                <tspan x="75" text-anchor="end">0.00</tspan>
                <tspan x="75"> - </tspan>
                <tspan text-anchor="start" x="90">${this.to.toFixed(2)}</tspan>`
              } else if (this.from === '无数据') {
                this.legendItem.element.innerHTML = `<tspan x="95" text-anchor="end">${this.from}</tspan>`
              } else {
                this.legendItem.element.innerHTML = `
                <tspan x="75" text-anchor="end">${this.from.toFixed(2)}</tspan>
                <tspan x="75"> - </tspan>
                <tspan text-anchor="start" x="90">${this.to.toFixed(2)}</tspan>`
              }
            })
            return `${this.from} - ${this.to}`
          },
          symbolRadius: 3,
          symbolHeight: 18,
          symbolWidth: 30,
          itemMarginTop: 3,
          itemStyle: {
            fontSize: '18px',
            fontFamily: 'Helvetica-Light,Helvetica',
            fontWeight: 300,
            color: '#737373',
          },
          x: 0,
          y: 0,
        },
        series,
      }
      Highcharts.mapChart(this.$refs.hChart, option)
    },
    // 调整政区标注的位置
    resolveData(data) {
      const seriesData = data.filter(l => l.regionId !== '-')
      seriesData.forEach((i) => {
        i.value = i.spotPercent
        i.name = i.regionAlias
      })
      const heBei = seriesData.find(i => i.name === '河北')
      if (heBei) {
        heBei.dataLabels = {
          x: -10,
          y: 15,
        }
      }
      const beijing = seriesData.find(i => i.name === '北京')
      if (beijing) {
        beijing.dataLabels = {
          x: 0,
          y: 0,
        }
      }
      const tianjin = seriesData.find(i => i.name === '天津')
      if (tianjin) {
        tianjin.dataLabels = {
          x: 10,
          y: 8,
        }
      }
      const guangdong = seriesData.find(i => i.name === '广东')
      if (guangdong) {
        guangdong.dataLabels = {
          x: 5,
          y: -8,
        }
      }
      const xianggang = seriesData.find(i => i.name === '香港')
      if (xianggang) {
        xianggang.dataLabels = {
          x: 15,
          y: 5,
        }
      }
      const aomen = seriesData.find(i => i.name === '澳门')
      if (aomen) {
        aomen.dataLabels = {
          x: -5,
          y: 10,
        }
      }
      const gansu = seriesData.find(i => i.name === '甘肃')
      if (gansu) {
        gansu.dataLabels = {
          x: 30,
          y: 30,
        }
      }
      const finderN = seriesData.find(i => i.name === '内蒙古')
      if (finderN) {
        finderN.dataLabels = {
          x: 10,
          y: 50,
        }
      }
      const haiNan = seriesData.find(i => i.name === '海南')
      if (haiNan) {
        haiNan.dataLabels = {
          x: -45,
          y: -65,
        }
      }
      const fujian = seriesData.find(i => i.name === '福建')
      if (fujian) {
        fujian.dataLabels = {
          x: 5,
          y: 5,
        }
      }
      const jiangsu = seriesData.find(i => i.name === '江苏')
      if (jiangsu) {
        jiangsu.dataLabels = {
          x: 5,
          y: -5,
        }
      }
      const shanxi = seriesData.find(i => i.name === '陕西')
      if (shanxi) {
        shanxi.dataLabels = {
          x: 5,
          y: 20,
        }
      }
      const heilongjiang = seriesData.find(i => i.name === '黑龙江')
      if (heilongjiang) {
        heilongjiang.dataLabels = {
          x: 5,
          y: 15,
        }
      }
      const taiwan = seriesData.find(i => i.name === '台湾')
      if (taiwan) {
        taiwan.dataLabels = {
          x: -5,
          y: 5,
        }
      }
      return seriesData
    },
    // 组织highCharts的数据结构
    getDataClasses(data) {
      const values = data.map(i => +i.spotPercent)
      const maxValue = +Math.max.apply(null, values).toFixed(4) + 0.01
      const stepA = +(maxValue / 10).toFixed(2)

      const colors = [ '#F8F4B9', '#F4E68A', '#F3DD84', '#EFC875', '#EAB459', '#E79B4E', '#DA922E', '#D7642A', '#CE4B2C', '#C55644' ]
      const arrStart = [
        {
          from: 'firstL',
          to: 0,
          color: '#aaaaaa',
        },
      ]
      const middleArr = colors.map((element, i) => {
        if (i === 0) {
          return {
            from: 0.0001,
            to: +(stepA * (i + 1)).toFixed(2),
            color: element,
          }
        }
        if (i === 9) {
          return {
            from: +(stepA * i).toFixed(2),
            to: maxValue,
            color: element,
          }
        }
        return {
          from: +(stepA * i).toFixed(2),
          to: +(stepA * (i + 1)).toFixed(2),
          color: element,
        }
      })

      const arrEnd = [{
        from: '无数据',
        to: 0,
        color: '#aaaaaa',
      }]
      return arrStart.concat(middleArr, arrEnd)
    },
    getRegionName(regionId) {
      const china = {
        100000: '中国',
        110000: '北京',
        120000: '天津',
        130000: '河北',
        140000: '山西',
        150000: '内蒙古',
        210000: '辽宁',
        220000: '吉林',
        230000: '黑龙江',
        310000: '上海',
        320000: '江苏',
        330000: '浙江',
        340000: '安徽',
        350000: '福建',
        360000: '江西',
        370000: '山东',
        410000: '河南',
        420000: '湖北',
        430000: '湖南',
        440000: '广东',
        450000: '广西',
        460000: '海南',
        500000: '重庆',
        510000: '四川',
        520000: '贵州',
        530000: '云南',
        540000: '西藏',
        610000: '陕西',
        620000: '甘肃',
        630000: '青海',
        640000: '宁夏',
        650000: '新疆',
        710000: '台湾',
        810000: '香港',
        820000: '澳门',
      }
      return china[regionId]
    },
  },
}
</script>

<style lang="scss">
// .highcharts-credits {
//   display: none;
// }
.work-cover-map {
  padding: 0 35px;
  margin-bottom: 40px;
}
.work-cover-map__map {
  height: 680px;
}
.work-cover-map__timeline {
  height: 70px;
  margin-top: 15px;
}
g.highcharts-legend-item {
  pointer-events: none;
}
</style>
